import { call, put, takeLatest } from 'redux-saga/effects';
import {
  searchCalculations,
  getCalculation as getCalculationApi,
  createCalculation as createCalculationApi,
  updateCalculation as updateCalculationApi,
  deleteCalculation as deleteCalculationApi,
  generateExcelForCalculation,
  importExcelCalculation,
  importExcelCalculationOld
} from '../../../services/calculation/calculation-service';
import {
  fetchCalculationsSuccess,
  fetchCalculationsFailure,
  fetchCalculationSuccess,
  fetchCalculationFailure,
  createCalculationSuccess,
  createCalculationFailure,
  updateCalculationSuccess,
  updateCalculationFailure,
  deleteCalculationSuccess,
  deleteCalculationFailure,
  exportCalculationSuccess,
  exportCalculationFailure,
  importCalculationSuccess,
  importCalculationFailure,
  importCalculationOldSuccess,
  importCalculationOldFailure
} from '../actions';
import {
  CREATE_CALCULATION_REQUEST,
  DELETE_CALCULATION_REQUEST, EXPORT_CALCULATION_REQUEST, FETCH_CALCULATION_REQUEST,
  FETCH_CALCULATIONS_REQUEST, IMPORT_CALCULATION_REQUEST, IMPORT_CALCULATION_OLD_REQUEST,
  UPDATE_CALCULATION_REQUEST
} from "../action-types";

// Worker Saga: Handles FETCH_CALCULATIONS_REQUEST action
function* fetchCalculationsSaga(action) {
  try {
    const { payload: params } = action;
    const response = yield call(searchCalculations, params);
    yield put(fetchCalculationsSuccess(response));
  } catch (error) {
    yield put(fetchCalculationsFailure(error.message));
  }
}

// Worker Saga: Handles FETCH_CALCULATION_REQUEST action
function* fetchCalculationSaga(action) {
  try {
    const { payload: { id } } = action;
    const calculation = yield call(getCalculationApi, id);
    yield put(fetchCalculationSuccess(calculation));
  } catch (error) {
    yield put(fetchCalculationFailure(error.message));
  }
}

// Worker Saga: Handles CREATE_CALCULATION_REQUEST action
function* createCalculationSaga(action) {
  try {
    const { payload: data } = action;
    const newCalculation = yield call(createCalculationApi, data);
    yield put(createCalculationSuccess(newCalculation));
  } catch (error) {
    yield put(createCalculationFailure(error.message));
  }
}

// Worker Saga: Handles UPDATE_CALCULATION_REQUEST action
function* updateCalculationSaga(action) {
  try {
    const { payload: { id, data } } = action;
    const updatedCalculation = yield call(updateCalculationApi, id, data);
    yield put(updateCalculationSuccess(updatedCalculation));
  } catch (error) {
    yield put(updateCalculationFailure(error.message));
  }
}

// Worker Saga: Handles DELETE_CALCULATION_REQUEST action
function* deleteCalculationSaga(action) {
  try {
    const { payload: { id } } = action;
    yield call(deleteCalculationApi, id);
    yield put(deleteCalculationSuccess({ id }));
  } catch (error) {
    yield put(deleteCalculationFailure(error.message));
  }
}

// Worker Saga: Handles EXPORT_CALCULATION_REQUEST action
function* exportCalculationSaga(action) {
  try {
    const { payload: { id } } = action;
    yield call(generateExcelForCalculation, id);
    yield put(exportCalculationSuccess());
  } catch (error) {
    yield put(exportCalculationFailure(error.message));
  }
}

// Worker Saga: Handles IMPORT_CALCULATION_REQUEST action
function* importCalculationSaga(action) {
  try {
    const { payload: { file } } = action;
    const result = yield call(importExcelCalculation, file);
    yield put(importCalculationSuccess(result));
  } catch (error) {
    yield put(importCalculationFailure(error.message));
  }
}

// Worker Saga: Handles IMPORT_CALCULATION_OLD_REQUEST action
function* importCalculationOldSaga(action) {
  try {
    const { payload: { file } } = action;
    const result = yield call(importExcelCalculationOld, file);
    yield put(importCalculationOldSuccess(result));
  } catch (error) {
    yield put(importCalculationOldFailure(error.message));
  }
}

// Watcher Saga: Watches for calculation related actions
function* watchCalculations() {
  yield takeLatest(FETCH_CALCULATIONS_REQUEST, fetchCalculationsSaga);
  yield takeLatest(FETCH_CALCULATION_REQUEST, fetchCalculationSaga);
  yield takeLatest(CREATE_CALCULATION_REQUEST, createCalculationSaga);
  yield takeLatest(UPDATE_CALCULATION_REQUEST, updateCalculationSaga);
  yield takeLatest(DELETE_CALCULATION_REQUEST, deleteCalculationSaga);
  yield takeLatest(EXPORT_CALCULATION_REQUEST, exportCalculationSaga);
  yield takeLatest(IMPORT_CALCULATION_REQUEST, importCalculationSaga);
  yield takeLatest(IMPORT_CALCULATION_OLD_REQUEST, importCalculationOldSaga);
}

export default watchCalculations;
